dom.prepend = (selector, content) => {
	dom.append(selector, content, true);
};
